export default __webpack_public_path__ + "static/media/cameraIcon.6193f2eb.svg";